import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Card } from "./UI";

export default function CollapsibleSettingsCard({
  title,
  description,
  icon,
  iconClassName = "bg-gradient-to-br from-blue-500 to-indigo-600",
  defaultExpanded = false,
  tourId,
  headerRight,
  children,
  className = "",
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const toggle = () => setExpanded((v) => !v);

  return (
    <div data-tour-id={tourId || undefined}>
      <Card className={className}>
        <div className="flex items-start gap-3">
          <button
            type="button"
            onClick={toggle}
            aria-expanded={expanded}
            className="flex flex-1 items-start gap-3 text-left min-w-0 group"
          >
            {icon && (
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center shadow-sm flex-shrink-0 ${iconClassName}`}
              >
                {icon}
              </div>
            )}
            <div className="flex-1 min-w-0 pt-0.5">
              <h2 className="text-base font-semibold text-slate-900 group-hover:text-indigo-700 transition-colors">
                {title}
              </h2>
              {description && (
                <p className="text-sm text-slate-500 mt-0.5">{description}</p>
              )}
            </div>
          </button>

          {headerRight && (
            <div className="flex-shrink-0 pt-1" onClick={(e) => e.stopPropagation()}>
              {headerRight}
            </div>
          )}

          <button
            type="button"
            onClick={toggle}
            aria-label={expanded ? "Collapse section" : "Expand section"}
            className="flex-shrink-0 p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors mt-0.5"
          >
            <ChevronDown
              size={18}
              className={`transition-transform ${expanded ? "rotate-180" : ""}`}
            />
          </button>
        </div>

        {expanded && (
          <div className="mt-5 pt-5 border-t border-slate-100">
            {children}
          </div>
        )}
      </Card>
    </div>
  );
}
